import React from 'react';

const COLORS = [
  ['#D50A0A','#8b0000'], ['#013369','#001830'], ['#4F2683','#2d1650'],
  ['#008E97','#005a60'], ['#E31837','#8b0d1f'], ['#203731','#0d1a14'],
  ['#0076B6','#004a73'], ['#97233F','#5a1526'], ['#00338D','#001f5e'],
  ['#FB4F14','#a33309'], ['#FFB612','#b37d00'], ['#006778','#003d47'],
];

function hashUsername(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export default function UserAvatar({ username, size = 36, style = {} }) {
  if (!username) return null;
  const idx = hashUsername(username) % COLORS.length;
  const [c1, c2] = COLORS[idx];
  const initials = username.slice(0, 2).toUpperCase();
  const fontSize = Math.round(size * 0.38);

  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: 'linear-gradient(135deg,' + c1 + ',' + c2 + ')',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Oswald', sans-serif", fontSize: fontSize,
      fontWeight: 700, color: '#fff', flexShrink: 0,
      boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      userSelect: 'none', letterSpacing: 0.5,
      ...style
    }}>
      {initials}
    </div>
  );
}
